import { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { trackBuyClick } from "@/lib/track";

export function GoRedirectPage() {
  const { slug } = useParams();
  const [failed, setFailed] = useState(false);
  const fired = useRef(false);
  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    api.get(`/go/${slug}`).then((r) => {
      trackBuyClick(r.data.product_id, `/go/${slug}`);
      setTimeout(() => window.location.replace(r.data.url), 150);
    }).catch(() => setFailed(true));
  }, [slug]);
  return (
    <div data-testid="go-redirect" className="max-w-xl mx-auto px-6 py-24 text-center text-[#5C5A56]">
      {failed ? (
        <>
          <p className="text-lg text-[#2C2B29]">This link doesn't exist anymore.</p>
          <Link to="/" className="hh-link text-sm mt-3 inline-block">Browse our top picks →</Link>
        </>
      ) : (
        <p>Taking you to Amazon.in…</p>
      )}
    </div>
  );
}
